module.exports = __webpack_public_path__ + "static/media/480.4aa380df.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-stones/dark/480.png
// module id = 2486
// module chunks = 2